export const DL2_DATA_ATTRIBUTE_NAME = 'data-dl2';
export const DL2_SCRIPT_TAG_NAME = 'dl2-script';
export const DATA_OMNITURE_PRODUCT_NAME = 'data-omniture-product-name';
export const DATA_OMNITURE_DOWNLOAD_BUTTON_TYPE = 'data-omniture-download-button-type';
export const MULTILANGUAGE_DELIMITER = ', ';
export const DL2_TYPENAMES = {
  'Build': 'Build',
  'Downloader': 'Downloader',
  'Application Control Plugin': 'Application Control Plugin',
  'Additional distributive': 'Additional distributive'
};
